const USER_PURGE = 'USER_PURGE';
const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING';
const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
const USER_LOGOUT = 'USER_LOGOUT';

const INVESTOR_PURGE = 'INVESTOR_PURGE';
const INVESTOR_LOGIN_LOADING = 'INVESTOR_LOGIN_LOADING';
const INVESTOR_LOGIN_SUCCESS = 'INVESTOR_LOGIN_SUCCESS';
const INVESTOR_LOGIN_FAILURE = 'INVESTOR_LOGIN_FAILURE';
const INVESTOR_LOGOUT = 'INVESTOR_LOGOUT';

const INVESTOR_REGISTER_ERROR_CLEAR = 'INVESTOR_REGISTER_ERROR_CLEAR';
const INVESTOR_REGISTER_LOADING = 'INVESTOR_REGISTER_LOADING';
const INVESTOR_REGISTER_SUCCESS = 'INVESTOR_REGISTER_SUCCESS';
const INVESTOR_REGISTER_FAILURE = 'INVESTOR_REGISTER_FAILURE';

const USER_REGISTER_ERROR_CLEAR = 'USER_REGISTER_ERROR_CLEAR';
const USER_REGISTER_LOADING = 'USER_REGISTER_LOADING';
const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
const USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';

const USER_CONNECT_WALLET_LOADING = 'USER_CONNECT_WALLET_LOADING';
const USER_CONNECT_WALLET_SUCCESS = 'USER_CONNECT_WALLET_SUCCESS';
const USER_CONNECT_WALLET_FAILURE = 'USER_CONNECT_WALLET_FAILURE';
const USER_CONNECT_WALLET_LOCK = 'USER_CONNECT_WALLET_LOCK';

const USER_WALLET_CHANGED = 'USER_WALLET_CHANGED';

const USER_PROFILE_UPDATE_LOADING = 'USER_PROFILE_UPDATE_LOADING';
const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS';
const USER_PROFILE_UPDATE_FAILURE = 'USER_PROFILE_UPDATE_FAILURE';
const USER_PROFILE_UPDATE_CLEAR_ERROR = 'USER_PROFILE_UPDATE_CLEAR_ERROR';

const USER_PROFILE_LOADING = 'USER_PROFILE_LOADING';
const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
const USER_PROFILE_FAILURE = 'USER_PROFILE_FAILURE';

export const userActions = {
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGOUT,
  USER_CONNECT_WALLET_LOADING,
  USER_CONNECT_WALLET_FAILURE,
  USER_CONNECT_WALLET_SUCCESS,
  USER_CONNECT_WALLET_LOCK,
  USER_WALLET_CHANGED,
  USER_REGISTER_LOADING,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAILURE,
  INVESTOR_LOGIN_LOADING,
  INVESTOR_LOGIN_SUCCESS,
  INVESTOR_LOGIN_FAILURE,
  INVESTOR_LOGOUT,
  INVESTOR_REGISTER_FAILURE,
  INVESTOR_REGISTER_LOADING,
  INVESTOR_REGISTER_SUCCESS,
  USER_PURGE,
  INVESTOR_PURGE,
  INVESTOR_REGISTER_ERROR_CLEAR,
  USER_REGISTER_ERROR_CLEAR,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_LOADING,
  USER_PROFILE_UPDATE_FAILURE,
  USER_PROFILE_LOADING,
  USER_PROFILE_SUCCESS,
  USER_PROFILE_FAILURE,
  USER_PROFILE_UPDATE_CLEAR_ERROR
};
